import moment from 'moment';
import { BACKEND_DATE_FORMAT } from '../../../config/helpers';

const getDefaultFilterOptionsForSelectedCurrency = ({
  currencyCode,
  filters,
  resultsPerPage,
  siteKey,
  defaultSortOrder,
}) => {
  const filterCurrencyData = filters.prices.find((price) => price.currency === currencyCode);

  if (!filterCurrencyData) {
    throw new Error(`Currency data not found for: ${currencyCode}`);
  }

  const today = moment().format(BACKEND_DATE_FORMAT);

  // Use dateRangeFilterFromDate if provided, but never before today
  let fromDate = today;
  if (filters.dateRangeFilterFromDate) {
    const configuredFrom = moment(filters.dateRangeFilterFromDate).format(BACKEND_DATE_FORMAT);
    fromDate = moment.max(moment(configuredFrom), moment(today)).format(BACKEND_DATE_FORMAT);
  }

  // Use dateRangeFilterToDate if provided
  const toDate = filters.dateRangeFilterToDate
    ? moment(filters.dateRangeFilterToDate).format(BACKEND_DATE_FORMAT)
    : undefined;

  const defaultFilterOptionsForSelectedCurrency = {
    fromDate,
    ...(toDate && { toDate }),
    page: 1,
    resultsPerPage,
    siteKey,
    packageTypes: '',
    inclusions: [],
    sortOrder: defaultSortOrder,
    // min & max range of overall prices from model
    minPrice: filterCurrencyData.minimumPriceValue,
    maxPrice: filterCurrencyData.maximumPriceValue,
    // user selected price from / to within mix/max price range
    priceFrom: filterCurrencyData.minimumPriceValue,
    priceTo: filterCurrencyData.maximumPriceValue,
  };

  // By default, include all tournament IDs
  if (filters?.tournaments?.length) {
    defaultFilterOptionsForSelectedCurrency.tournaments = filters.tournaments.map((t) => t.id);
  }

  return defaultFilterOptionsForSelectedCurrency;
};

export default getDefaultFilterOptionsForSelectedCurrency;
